import { Component, computed, inject, Input, signal, SimpleChanges, WritableSignal, OnChanges } from '@angular/core';
import { TagApiService } from '@mavles/shared';
import { ITag } from '@mavles/shared';

@Component({
  selector: 'app-contact-tag-manager',
  templateUrl: './contact-tag-manager.component.html',
  styleUrl: './contact-tag-manager.component.scss',
  standalone: false
})
export class ContactTagManagerComponent implements OnChanges {
 @Input() contactId: number | null = null;

  private tagService = inject(TagApiService);

  allTags: WritableSignal<ITag[]> = signal([]);
  attachedTags: WritableSignal<ITag[]> = signal([]);
  loading: WritableSignal<boolean> = signal(false);

  availableTags = computed(() => {
    const attachedIds = new Set(this.attachedTags().map(t => t.id));
    return this.allTags().filter(tag => !attachedIds.has(tag.id));
  });


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['contactId'] && this.contactId) {
      this.fetchTags();
    }
  }

  private fetchTags(): void {
    this.loading.set(true);
    // Fetch all tags first
    this.tagService.getAllTags().subscribe(allTags => {
      this.allTags.set(allTags.data);
      // Then fetch tags for the specific contact
      if (this.contactId) {
        this.tagService.getTagsByContactId(this.contactId).subscribe(response => {
          this.attachedTags.set(response.data);
          this.loading.set(false);
        });
      }
    });
  }

  attachTag(tagId: number): void {
    if (this.contactId) {
      this.tagService.attachTag(this.contactId, tagId).subscribe({
        next: () => this.fetchTags(),
        error: (err) => console.error('Error attaching tag:', err)
      });
    }
  }

  detachTag(tagId: number): void {
    if (this.contactId) {
      this.tagService.detachTag(this.contactId, tagId).subscribe({
        next: () => this.fetchTags(),
        error: (err) => console.error('Error detaching tag:', err)
      });
    }
  }
}


